// extracted by mini-css-extract-plugin
export var navbarSubLink = "bc_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "bc_v3 d_f0 d_dB";
export var subPageLink = "bc_gf d_gf";
export var burger = "bc_ym";
export var sublinkSize = "bc_yn";
export var linkSize = "bc_yp";
export var Link = "bc_t0 J_t0 J_tv J_tQ";